import ApiService from './api.service';

class UserService {
  static async getAuthenticatedUser() {
    const response = await ApiService.get(`${window.ambulnzConfig.tenantedRestApiUrl}/AmbUsers/whoami`, null, {
      noCache: true,
    });
    return response.json();
  }

  static async getUserFacilities(userId) {
    const filter = {
      include: {
        requesterAgency: ['entity', 'payers', { requesterAgencyGroup: 'patientStoreAdapters' }, 'requesterOptions'],
      },
    };
    const response = await ApiService.get(
      `${window.ambulnzConfig.tenantedRestApiUrl}/AmbUsers/${userId}/Facilities?filter=${JSON.stringify(filter)}`,
    );
    return response.json();
  }

  static async setPreferredUserFacility(userId, facilityId) {
    const response = await ApiService.patch(
      `${window.ambulnzConfig.tenantedRestApiV2Url}/AmbUser/${userId}/setPreferredFacility`,
      { facilityId },
    );
    return response.json();
  }

  static async unsetAllPreferredUserFacilities(userId) {
    const response = await ApiService.delete(
      `${window.ambulnzConfig.tenantedRestApiV2Url}/AmbUser/${userId}/preferredFacilities`,
    );
    return response.json();
  }
}

export default UserService;
